import { qsa } from '@fluorescent/dom';

import Accordions from '@/lib/accordion';

export const accordions = node => {
  const accordions = Accordions(qsa('.accordion', node));

  return {
    destroy: () => {
      accordions.destroy();
    },
  };
};

export function wrapIframes(elements = []) {
  elements.forEach(el => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte__iframe');

    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    el.src = el.src;
  });
}
